<template>
  <div class="m-0 h-screen-fixed fixed pin pbc-modal-background flex justify-center left-0 top-0 right-0 bottom-0 inset-y-auto pbc-z-level-2" @click.self='$emit("close")'>
    <div class="animated fadeInUp fixed shadow-inner max-w-md md:max-w-3xl pin-b pin-x align-top m-auto justify-center w-full shadow flex flex-col mb-4 flex h-full">
        <div class="m-2 rounded flex flex-col overflow-hidden" style='box-sizing: border-box' :class="fullHeight? 'grow':''">
          <slot name='controls' :close='close' :done='done'>
            <div class="py-3 w-full flex justify-between inline-flex">
              <pbc-button v-if='showCancel' @click="close" class="pbc-minimal-button">
                <close class="mx-2"/>
              </pbc-button>
              <pbc-button @click="$emit('done')" class="pbc-minimal-button">
                <check class="mx-1" />
                <span class="mr-1">OK</span>
              </pbc-button>
            </div>
          </slot>

          <slot name='default' :close='close' :done='done' />
        </div>
	</div>
</div>
</template>
<script>
import Check from '@icons/Check.vue';
import Close from '@icons/Close.vue';
export default {
  props:{
    title:{
      type:String,
      default:'Title'
    },
    disableTitle:{
      type:Boolean,
      default:false
    },
    showCancel:{
      type:Boolean,
      default:true
    },
    backgroundColor:{
      type:String,
      default:'#ffffff'
    },
    fullHeight: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.$store.commit('popupBeingShown', true);
  },
  beforeDestroy() {
    this.$store.commit('popupBeingShown', false);
  },
  components:{
    Check,
    Close
  },
  methods:{
    close(dontEmit) {
      if (!dontEmit) {
        this.$emit('close');
      }
    },
    done() {
      this.$emit('done');
    }
  },
  computed: {
    backgroundStyle() {
      return {
        'background-color':this.backgroundColor
      }
    }
  }
}
</script>
